module.exports = __webpack_public_path__ + "static/media/aci_brand.5607b257.png";